import React, { useReducer } from 'react';
import { UIHeading1 } from '@cian/ui-kit';

import { BreadCrumbsContainer } from '../BreadCrumbs';
import { BlogPostFormLayout as Layout } from '../../components/BlogPostFormLayout';
import { TitleField, FeaturedImageField } from '../../components/PostFormFields';
import { blogPostFormReducer, blogPostInitialState, useFeaturedImageField, useTitleField } from '../../utils/postForm';

/**
 * Контейнер формы добавления/редактирования поста блога
 */
export const BlogPostFormContainer = () => {
  const [state, dispatch] = useReducer(blogPostFormReducer, blogPostInitialState);
  const titleFieldProps = useTitleField(state, dispatch);
  const featuredImageProps = useFeaturedImageField(state, dispatch);
  const heading = 'Новая запись';

  return (
    <>
      <BreadCrumbsContainer />
      <Layout
        heading={<UIHeading1>{heading}</UIHeading1>}
        titleField={<TitleField {...titleFieldProps} />}
        featuredImageField={<FeaturedImageField {...featuredImageProps} />}
      />
    </>
  );
};
